module.exports = "https://web-assets.ifttt.com/packs/media/icons/cloudy-f56d2b6b.png";